var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',{staticClass:"cntntLoad"},[_c('img',{attrs:{"width":"40","height":"40","src":require("../assets/images/loader.gif")}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }